module.exports = __webpack_public_path__ + "img/tge.47ab2f99.png";